import ImageBuddy from 'imagebuddy';
import SiteEvents from '../util/site-events';

class BlockSlider {
	constructor($block, Swiper) {
		this.$block = $block;
		this.$swiperContainer = this.$block.find('.swiper-container').first();

		this.displayTime = Number(this.$swiperContainer.attr('data-display-time'));
		this.transitionTime = Number(this.$swiperContainer.attr('data-transition-time'));

		ImageBuddy.on('image-loaded', (imgEl) => {
			if (jQuery.contains(this.$swiperContainer.get(0), imgEl) && this.swiperInstance) {
				this.swiperInstance.update();
			}
		});

		this.swiperInstance = new Swiper(this.$swiperContainer.get(0), {
			speed: this.transitionTime ? this.transitionTime * 1000 : 500,
			autoplay: this.displayTime ? this.displayTime * 1000 : false,
			slidesPerView: 'auto',
			direction: 'horizontal',
			loop: true,
			navigation: {
				prevEl: this.$block.find('.swiper-button-prev').first().get(0),
				nextEl: this.$block.find('.swiper-button-next').first().get(0)
			},
			on: {
				init: function () {
					SiteEvents.imageBuddyUpdate();
				}
			}
		});
	}
}

export default BlockSlider;
